// Styles
import styles from './style.module.scss';

const Divider = ({ ...props }) => <div className={styles.Divider} {...props} />;

export default Divider;
